function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 10c0-1.294.416-2.49 1.115-3.47l8.356 8.355A5.952 5.952 0 0 1 10 16c-3.31 0-6-2.69-6-6zm12 0c0 1.294-.416 2.49-1.115 3.47L6.53 5.116A5.94 5.94 0 0 1 10 4c3.31 0 6 2.69 6 6zM2 10c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/cancel.c04a6d09.svg";
export { SvgComponent as ReactComponent };